import { $errorReporter } from '../../$libs/$errorReporter/$errorReporter'
import { $appHook } from '../../../common/$appHook'
import { $directusSdk } from '../../../common/$directusSdk'
import { embAuthHooks } from './$embAuth'

// register hooks
export const registerDefalutEmailPasswordEmbAuthActions = () => {
  // signIn Error
  $appHook.on(
    embAuthHooks.signIn.ERROR,
    () => {
      $core.$toast.errorToast(
        $core.$dict.get(
          'signInFailedDisplayMessage',
          'ログインできませんでした、メールアドレスまたはパスワードを確認してください。',
        ),
      )
      return true // Avoid throw error
    },
    'showErrorMessage',
  )

  // SignIn 実行
  $appHook.on(
    embAuthHooks.signIn.DO,
    // @ts-ignore
    (args, executionContext) => {
      const { email, password } = executionContext?.additionalArgs || {}
      try {
        // @ts-ignore
        $directusSdk.auth.resetStorage()
        // @ts-ignore
        $directusSdk.auth._refreshPromise = undefined
      } catch (e) {
        console.error(e)
      }
      return $directusSdk.auth.login({ email, password })
    },
    'do',
  )

  // SignIn.AFTER
  const signedInCallbackDefault = (userData) => {
    $core.$toast.successToast(
      $core.$dict.get('signInSucceededDisplayMessage', 'ログインしました。'),
    )
    if ($core.$router) {
      // TODO: FIXME!
      const route = $core.$router.currentRoute
      const redirectTo =
        route.query?.redirectTo && route.query.redirectTo !== 'undefined'
          ? decodeURIComponent(route.query.redirectTo.toString())
          : '/'
      $core.$router.push(redirectTo)
      // $core.$router.push('/')
    }
  }
  $appHook.on(
    embAuthHooks.signIn.AFTER,
    async (user) => {
      if ($core?.$toast) {
        return $core.$configVars.get(
          'embAuth.signedIn.successCallback',
          signedInCallbackDefault,
        )(user)
      }
    },
    'redirection',
  )

  // UserData取得
  $appHook.on(
    embAuthHooks.getUserData.DO,
    async (args) => {
      if (!$directusSdk.auth.token) {
        return null
      }
      try {
        const getUserQueryFunc = await $core.$configVars.get(
          'embAuth.getUserDataOptionsResolveFunc',
          async () => {
            return {
              fields: ['*.*'],
            }
          },
        )
        const userQuery = await getUserQueryFunc()
        const me = await $directusSdk.users.me.read(
          userQuery,
        )
        me.name = (me.last_name || '') + (me.first_name || '') || me.name
        if (!me.name) {
          me.name = me.email
        }
        return me
      } catch (e) {
        console.error(
          `[registerEmbAuthActionsWithDirectusAuth] embAuthHooks.getUserData.DO`,
          { e },
        )
        return null
      }
    },
    'do',
  )
  // UserData取得失敗 = ログアウトする
  $appHook.on(
    embAuthHooks.getUserData.ERROR,
    async (args, { callerContext }) => {
      console.log(`[${embAuthHooks.getUserData.ERROR}]`, {
        callerContext,
        args,
      })
      await callerContext.signOut()
    },
    'default',
  )
  // Refresh
  $appHook.on(
    embAuthHooks.refreshUserData.DO,
    async (args) => {
      await $core.$embAuth.getUserData()
      return args
    },
    'do',
  )

  // signOut
  $appHook.on(
    embAuthHooks.signOut.DO,
    async () => {
      if ($directusSdk.auth.token) {
        try {
          if ($directusSdk.auth.mode === 'json') {
            try {
              await $directusSdk.auth.logout()
            } catch (e) {
              console.error(e)
            }
          }
          // @ts-ignore
          await $directusSdk.auth.resetStorage()

          // ログアウト時、ログイン画面にリダイレクト
          $core.$router.push($core.$configVars.get('signInRedirectTo', '/signIn'))
          setTimeout(() => {
            // URL の 遷移を確実に完了したうえで Reload
            window.location.reload()
          }, 100)
        } catch (e) {
          $errorReporter.r(e, this)
        }
      }
    },
    'do',
  )

  // embAuthHooks.updateUserData.
  $appHook.on(
    embAuthHooks.updateUserData.DO,
    async (args) => {
      const userData = args
      const userRaw = await $directusSdk.users.me.update(userData)
      return userRaw
    },
    'do',
  )
}
